<template>
  <div class="editPic_row_item" v-show="currThemeObj">
    <div class="mixtmt_uploadList_li">
      <div class="mixtmt-upload-image__preview" :class="uploadType">
        <el-image
          v-if="uploadType === 'uploadImage'"
          style="width: 4.86vw; height: 4.86vw"
          :src="rowItem.url"
          fit="contain"
          :preview-src-list="[rowItem.url]"
        />
        <div v-if="uploadType === 'uploadVideo'">
          <video
            :src="rowItem.url"
            style="width: 4.86vw; height: 4.86vw"
            controls="controls"
          >
            您的浏览器不支持播放器
          </video>
        </div>
        <div v-if="uploadType === 'uploadAudio'">
          <audio :src="rowItem.url" controls>您的浏览器不支持播放器</audio>
        </div>
        <div v-if="uploadType === 'uploadFile'">
          <span class="el-icon-document"></span>
        </div>
        <el-tooltip
          v-if="false"
          effect="dark"
          :content="computFileName(rowItem.name)"
          placement="top-start"
          :popper-class="tooltipPopperClass ? tooltipPopperClass : ''"
          :disabled="
            computFileName(rowItem.name).length <=
            `${uploadType === 'uploadAudio' ? 42 : 42}`
          "
        >
          <!-- 不需要显示上传进度所以无论类型字数都一致 -->
          <span
            class="image_name"
            v-text="
              computFileName(rowItem.name).length >
              `${uploadType === 'uploadAudio' ? 24 : 11}`
                ? `${computFileName(rowItem.name).substring(
                    0,
                    `${uploadType === 'uploadAudio' ? 23 : 10}`
                  )}...`
                : computFileName(rowItem.name)
            "
          ></span>
        </el-tooltip>
        <span class="image_name">
          <el-input
            v-model="inputImageName"
            placeholder="请输入图片名称"
            @change="imageInputChange"
          ></el-input>
        </span>

        <span
          class="picSizeText"
          v-text="`图片尺寸：${rowItem.picWidth}*${rowItem.picHeight}`"
        ></span>
        <!-- <span class="elProgress_box">
          <el-progress
            v-show="rowItem.status === 'progress'"
            :percentage="rowItem.percentage"
          />
        </span> -->

        <span class="elButton_box" :class="[uploadType, rowItem.status]">
          <!-- 从本地上传图片到网页 -->
          <span
            class="operate_btn locationUploadPic"
            @click="clickOperateBtn('locationUploadPic')"
          >
            <svg
              t="1720713210848"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="20995"
              width="60%"
              height="60%"
            >
              <path
                d="M224.028444 96.028444A159.971556 159.971556 0 0 0 64 256v447.317333a30.72 30.72 0 0 0 0 1.422223V768a159.971556 159.971556 0 0 0 160.028444 160.028444h351.971556a31.971556 31.971556 0 1 0 0-64H224.028444A95.971556 95.971556 0 0 1 128 768v-45.454222l190.065778-108.600889 207.36 148.081778a31.971556 31.971556 0 1 0 37.148444-52.053334l-98.190222-70.144 241.777778-214.926222 189.838222 135.566222v15.530667a32.028444 32.028444 0 0 0 64 0V256a160.028444 160.028444 0 0 0-160.028444-160.028444H224.028444zM682.666667 360.106667l-271.758223 241.550222-72.362666-51.712a31.971556 31.971556 0 0 0-34.474667-1.706667L128 648.874667V256c0-53.020444 43.008-96.028444 96.028444-96.028444h576c52.963556 0 95.971556 43.008 95.971556 96.028444v225.848889l-173.397333-123.904a32.028444 32.028444 0 0 0-39.822223 2.161778z m-394.695111-40.106667a31.971556 31.971556 0 1 1 64 0 31.971556 31.971556 0 0 1-64 0z m31.971555-96.028444a95.971556 95.971556 0 1 0 0 192 95.971556 95.971556 0 0 0 0-192z"
                p-id="20996"
              ></path>
              <path
                d="M703.431111 828.302222h224.711111a26.510222 26.510222 0 0 1 19.114667 45.852445l-46.933333 46.819555a26.339556 26.339556 0 0 1-37.432889 0 26.453333 26.453333 0 0 1 0-37.432889l2.275555-2.332444h-161.735111a26.453333 26.453333 0 1 1 0-52.906667z m232.448 19.797334zM929.28 783.075556h-224.711111a26.510222 26.510222 0 0 1-19.114667-45.852445l46.990222-46.762667a26.339556 26.339556 0 0 1 37.376-0.056888 26.453333 26.453333 0 0 1 0 37.432888l-2.275555 2.332445h161.735111a26.453333 26.453333 0 1 1 0 52.906667z m-232.448-19.797334z"
                p-id="20997"
              ></path>
            </svg>
          </span>

          <!-- 裁切按钮 -->
          <span
            class="operate_btn crop"
            @click="clickOperateBtn('crop')"
            v-if="uploadType === 'uploadImage'"
          >
            <svg
              t="1720712807185"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="11713"
              width="60%"
              height="60%"
            >
              <path
                d="M981.333333 789.333333h-106.666666V256c0-59.733333-46.933333-106.666667-106.666667-106.666667H234.666667V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667s-42.666667 17.066667-42.666667 42.666667v106.666666H42.666667c-25.6 0-42.666667 17.066667-42.666667 42.666667s17.066667 42.666667 42.666667 42.666667h106.666666V768c0 59.733333 46.933333 106.666667 106.666667 106.666667h533.333333V981.333333c0 25.6 17.066667 42.666667 42.666667 42.666667s42.666667-17.066667 42.666667-42.666667v-106.666666H981.333333c25.6 0 42.666667-17.066667 42.666667-42.666667s-17.066667-42.666667-42.666667-42.666667z m-213.333333-554.666666c12.8 0 21.333333 8.533333 21.333333 21.333333v341.333333l-145.066666-140.8c-17.066667-17.066667-42.666667-17.066667-59.733334 0l-140.8 145.066667L384 541.866667c-17.066667-17.066667-38.4-17.066667-55.466667-4.266667l-89.6 72.533333V234.666667H768z m-512 554.666666c-12.8 0-21.333333-8.533333-21.333333-21.333333v-42.666667l115.2-93.866666 64 64c8.533333 8.533333 17.066667 12.8 29.866666 12.8s21.333333-4.266667 29.866667-12.8l140.8-145.066667 174.933333 166.4v72.533333H256z"
                p-id="11714"
              ></path>
              <path
                d="M384 482.133333c51.2 0 93.866667-42.666667 93.866667-93.866666s-42.666667-93.866667-93.866667-93.866667-93.866667 38.4-93.866667 89.6 42.666667 98.133333 93.866667 98.133333z m0-128c17.066667 0 34.133333 12.8 34.133333 34.133334s-17.066667 29.866667-34.133333 29.866666-34.133333-17.066667-34.133333-34.133333 17.066667-29.866667 34.133333-29.866667z"
                p-id="11715"
              ></path>
            </svg>
          </span>

          <!-- <el-button
            v-if="rowItem.status !== 'progress' && rowItem.status !== 'success'"
            type="success"
            class="el-icon-upload ml16"
            size="small"
            circle
            @click="loactionPreview(rowItem)"
          /> -->

          <!-- 抠图按钮 -->
          <span class="operate_btn cutout" @click="clickOperateBtn('cutout')">
            <svg
              t="1720711919641"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="10582"
              width="60%"
              height="60%"
            >
              <path
                d="M352.9081 153.571845c-71.666861 0-129.853527 57.282298-129.853527 127.976538s58.186666 127.976538 129.853527 127.976537c71.700988 0 129.853527-57.282298 129.853527-127.976537S424.660279 153.571845 352.9081 153.571845z m0 0c-71.666861 0-129.853527 57.282298-129.853527 127.976538s58.186666 127.976538 129.853527 127.976537c71.700988 0 129.853527-57.282298 129.853527-127.976537S424.660279 153.571845 352.9081 153.571845zM304.242889 452.183766C211.587876 452.183766 136.508307 526.205396 136.508307 617.495326v10.613521C136.508307 665.443869 211.622003 665.477996 304.242889 665.477996h108.21696C505.080735 665.477996 580.160304 664.095849 580.160304 628.108847v-10.630585c0-91.255803-75.079569-165.277432-167.700455-165.277432h-108.199897z"
                p-id="10583"
              ></path>
              <path
                d="M995.964606 521.120461L822.786756 745.847261 640.445785 511.906151s-56.719201 70.74543-3.071437 146.200396c53.647765 75.403776 185.412408 227.798237 185.412408 227.798237l191.555281-244.69114s30.663178-56.975155-18.377431-120.093183zM821.353419 838.96299a26.875073 26.875073 0 1 1 0-53.750146 26.875073 26.875073 0 0 1 0 53.750146z m112.926496 5.528587c-49.296562 0-89.276433 40.133442-89.276432 89.685957 0 49.450134 39.97987 89.634767 89.276432 89.634767 49.347753 0 89.327623-40.133442 89.327624-89.685957 0-49.501325-39.97987-89.634767-89.327624-89.634767z m0 134.784889a45.047741 45.047741 0 0 1-44.894169-45.150122 45.047741 45.047741 0 0 1 44.894169-45.047742 45.047741 45.047741 0 0 1 41.600907 62.298979 45.047741 45.047741 0 0 1-41.600907 27.898885z m-223.702987-134.784889c-49.398944 0-89.327623 40.133442-89.327624 89.685957 0 49.450134 39.92868 89.634767 89.276433 89.634767 49.296562 0 89.276433-40.133442 89.276433-89.685957 0-49.501325-39.97987-89.634767-89.276433-89.634767h0.051191z m0 134.784889a45.064805 45.064805 0 0 1-45.047742-45.150122 45.047741 45.047741 0 0 1 44.996551-45.047742 45.047741 45.047741 0 0 1 44.894169 45.047742 45.047741 45.047741 0 0 1-44.894169 45.150122h0.051191zM453.702421 780.042592a36.550099 36.550099 0 0 1 0 73.100198H134.119411A134.051157 134.051157 0 0 1 0 719.07457V134.119411A134.068221 134.068221 0 0 1 134.068221 0h633.739814a134.068221 134.068221 0 0 1 134.119412 134.068221v228.822049a36.567163 36.567163 0 1 1-73.151389 0V134.119411A60.916832 60.916832 0 0 0 767.859226 73.151389H134.068221a60.916832 60.916832 0 0 0-60.916832 60.916832v585.006349a60.899768 60.899768 0 0 0 60.916832 60.916832h319.6342v0.05119z"
                p-id="10584"
              ></path>
            </svg>
          </span>

          <!-- 显示|隐藏 -->
          <span class="operate_btn showPic" @click="clickOperateBtn('showPic')">
            <template v-if="rowItem.isShowPic">
              <svg
                t="1722445177348"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="14990"
                width="60%"
                height="60%"
              >
                <path
                  d="M792.241 483.333l84.29 122.162c14.246 20.646 9.057 48.932-11.59 63.178-20.646 14.245-48.931 9.056-63.177-11.59l-96.235-139.475c-46.873 14.454-96.675 23.726-148.11 27.177V711.13c0 25.084-20.335 45.418-45.419 45.418-25.084 0-45.419-20.334-45.419-45.418V544.785c-51.435-3.451-101.237-12.723-148.11-27.177l-96.235 139.475c-14.246 20.646-42.531 25.835-63.177 11.59-20.647-14.246-25.836-42.532-11.59-63.178l84.29-122.162c-71.278-34.968-132-83.323-176.087-142.072-15.055-20.064-10.996-48.533 9.067-63.589 20.064-15.055 48.533-10.996 63.589 9.067C205.442 389.502 350.61 455.466 512 455.466c161.39 0 306.558-65.964 383.672-168.727 15.056-20.063 43.525-24.122 63.589-9.067 20.063 15.056 24.122 43.525 9.067 63.589-44.087 58.75-104.809 107.104-176.087 142.072z"
                  p-id="14991"
                ></path>
              </svg>
            </template>
            <template v-else>
              <svg
                t="1722445673370"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="15988"
                width="60%"
                height="60%"
              >
                <path
                  d="M924.1 446.3c-75.7-68.5-229.7-183.5-411-183.5-181.5 0-335.6 115.2-411.3 183.8-18 16.3-28.4 39.6-28.4 63.8 0 24.2 10.3 47.5 28.4 63.8C177.5 642.8 331.7 758 513.1 758c181.3 0 335.3-115 411-183.5 18.1-16.4 28.5-39.8 28.5-64.1 0-24.3-10.4-47.7-28.5-64.1z m-44.3 79.3C811.2 587.8 672.3 692 513.1 692c-159.3 0-298.3-104.4-367-166.7-5.8-5.3-6.7-11.6-6.7-14.9 0-3.3 0.9-9.7 6.7-14.9 68.7-62.3 207.6-166.7 367-166.7 159.1 0 298 104.3 366.7 166.4 5.9 5.3 6.8 11.8 6.8 15.2s-0.9 9.9-6.8 15.2z"
                  p-id="15989"
                ></path>
                <path
                  d="M513 378.4c-72.8 0-132.1 59.2-132.1 132.1s59.3 132 132.1 132 132.1-59.2 132.1-132.1-59.2-132-132.1-132z m0 198.1c-36.4 0-66-29.6-66-66s29.6-66 66-66 66 29.6 66 66-29.6 66-66 66z"
                  p-id="15990"
                ></path>
              </svg>
            </template>
          </span>

          <!-- 上移图层 -->
          <span
            v-if="isMoveBtnState.includes('moveUp')"
            class="operate_btn moveUp"
            @click="clickOperateBtn('moveUp')"
          >
            <svg
              t="1722586667514"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="14602"
              width="60%"
              height="60%"
            >
              <path
                d="M896 832h-128v64a96 96 0 0 1-96 96H128a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96h96v64H128a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h544a32 32 0 0 0 32-32v-64H320a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h576a96 96 0 0 1 96 96v608a96 96 0 0 1-96 96z m32-704a32 32 0 0 0-32-32H320a32 32 0 0 0-32 32v608a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V128z m-288 242.24V640h-64v-271.488l-74.656 77.888-52.896-55.2 158.72-166.784 160.384 167.36-53.472 55.776z"
                p-id="14603"
              ></path>
            </svg>
          </span>

          <!-- 下移图层 -->
          <span
            v-if="isMoveBtnState.includes('moveDown')"
            class="operate_btn moveDown"
            @click="clickOperateBtn('moveDown')"
          >
            <svg
              t="1722586480788"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="12785"
              width="60%"
              height="60%"
            >
              <path
                d="M896 832h-128v64a96 96 0 0 1-96 96H128a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96h96v64H128a32 32 0 0 0-32 32v640a32 32 0 0 0 32 32h544a32 32 0 0 0 32-32v-64H320a96 96 0 0 1-96-96V128a96 96 0 0 1 96-96h576a96 96 0 0 1 96 96v608a96 96 0 0 1-96 96z m32-704a32 32 0 0 0-32-32H320a32 32 0 0 0-32 32v608a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V128zM448.448 472.224l53.472-55.776L576 493.76V224h64v271.488l74.624-77.888 52.896 55.2-158.72 166.784z"
                p-id="12786"
              ></path>
            </svg>
          </span>
        </span>
        <span
          class="item_stateIcon success"
          v-if="rowItem.status === 'success'"
        >
          <i class="el_icon__upload_success">
            <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="currentColor"
                d="M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"
              ></path>
            </svg>
          </i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import dataPoster_base_data_mixin from '@mixins/dataPoster_base_data'
export default {
  name: 'editPic_row_item',
  components: {},
  mixins: [dataPoster_base_data_mixin],
  props: {
    tooltipPopperClass: {
      type: String,
      default: '',
    },
    rowItem: {
      type: Object,
      default: () => {
        return {
          // 这个属性不全，带最终同步
          isShowPic: true,
          name: '麦克风.jpg',
          percentage: 100,
          status: 'success', //'location':刚从本地读取文件到浏览器未上传； 'progress':正在向oss上传；'success':已经上传成功
          size: 24531,
          picWidth: 0,
          picHeight: 0,
          raw: {},
          uid: 1678249363302,
          // url: 'https://hyper-sports-res.mixtmt.com/app/competition/small/SOG.png',
          url: require(`@src/assets/images/platfrom_mixtmt/loginPage_log.png`), //图片 视频 音频等用这个
          submitVal: 'hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //不要oss域名的路径
          absOssUrl:
            'http://mixtmt-images.oss-cn-beijing.aliyuncs.com/hyper/%E9%BA%A6%E5%85%8B%E9%A3%8E.jpg', //oss生产的在线地址
        }
      },
    },
    uploadType: {
      type: String,
      default: 'uploadImage',
    },
    indexArr: {
      type: Array,
      default: () => {
        return [0, 0]
      },
    },
  },
  data() {
    return {
      inputImageName: '',
    }
  },
  watch: {
    rowItem(newVal, oldVal) {
      // console.debug('rowItem:', newVal)
      this.inputImageName = newVal ? newVal.name : ''
    },
    immediate: true,
    deep: true,
  },
  created() {
    this.init()
  },
  computed: {
    isMoveBtnState() {
      let className = []
      const indexArr = this.indexArr // [图片总个数，当前图片索引]
      if (indexArr[0] - 1 === indexArr[1]) {
        // 开头：[0,0] || 结尾：[n, n]
        if (indexArr[1] === 0) {
          // 说明只有一个图片， 不显示上移|下移
        } else if (indexArr[1] > 0) {
          //说明只多个图片，索引为在最后 [n, n]，只显示上移
          className = ['moveUp']
        } else {
          console.debug('未知情况')
        }
      } else {
        // 多个图片走这里
        if (indexArr[1] === 0) {
          // 在第一个位置， [>1, 0]，显示下移
          className = ['moveDown']
        } else {
          // 其他情况上移|下移都显示；最后一个的逻辑不在这里，在上面
          className = ['moveUp', 'moveDown']
        }
      }
      return className
    },
  },
  methods: {
    async init() {
      this.inputImageName = this.rowItem ? this.rowItem.name : ''
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickInputFile() {
      this.$emit('clickInputFileEvent', { item: this.rowItem })
    },
    imageInputChange(val) {
      console.debug(val, this.rowItem)
      let rowItem = JSON.parse(JSON.stringify(this.rowItem))
      rowItem.name = val
      this.$emit('changeItemPicEvent', {
        type: 'changeImageName',
        data: rowItem,
      })
    },
    computFileItem(itemUrl, name) {
      let pathArr = itemUrl.split('?')
      let type = pathArr[0].split('.').pop()
      return {
        status: 'success',
        name: `${name}.${type}`,
        url: itemUrl,
        submitVal: itemUrl,
      }
    },
    computFileName(fileName) {
      // console.debug(fileName)
      const fileNameArr = fileName.split('?')
      return fileNameArr[0]
    },
    loactionPreview(file) {
      // 上传服务器
      this.$emit('loactionPreviewEvent', {
        data: file,
      })
    },
    cropPreview(file) {
      // 裁切图片
      console.debug('cropPreview:', file, this.rowItem)
      this.$emit('cropPreviewEvent', {
        data: file,
      })
    },
    clickOperateBtn(state) {
      if (state === 'crop') {
        // 截图
        this.cropPreview(this.rowItem)
      } else if (state === 'cutout') {
        // 抠图
        this.$emit('cutoutImageEvent', {
          type: state,
          data: this.rowItem,
        })
      } else if (state === 'showPic') {
        this.$emit('changeItemPicEvent', {
          type: state,
          data: this.rowItem,
        })
      } else if (state === 'locationUploadPic') {
        // 本地上传图片，只是暂存在浏览器，不上传服务器
        this.clickInputFile()
      } else if (['moveUp', 'moveDown'].includes(state)) {
        this.$emit('changeItemPicEvent', {
          type: state,
          data: this.rowItem,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.editPic_row_item {
  padding: 0;
  width: 100%;
  list-style: none;
  position: relative;
  .mixtmt_uploadList_li {
    overflow: hidden;
    z-index: 0;
    background-color: var(--mixtmt_whiteColor);
    border: 1px solid var(--mixtmt_greyColor8);
    border-radius: 0.533vw;
    box-sizing: border-box;
    margin-top: 0.694vw;
    padding: 0.694vw;
    display: flex;
    align-items: center;
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
    margin-bottom: 0.347vw;
    position: relative;
    width: 100%;
    .mixtmt-upload-image__preview {
      position: relative;
      width: 100%;
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.972vw;
      &.uploadAudio {
        padding: 0 0 2.083vw 0;
        .image_name {
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 2;
          width: 50%;
        }
        /* .elProgress_box {
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 50%;
        } */
      }
      .image_name {
        /* width: 8.333vw; */
        width: calc(100% - 4.86vw - 20vw);
        /* flex: 1; */
        padding: 0 0.694vw;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      /* .elProgress_box {
        flex: 1;
      } */
      .picSizeText {
        width: 16.8vw;
      }
      .elButton_box {
        width: 20vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        padding-right: 0.694vw;
        &.uploadVideo.progress,
        &.uploadVideo.success {
          width: 3.472vw;
        }
        .operate_btn {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 2.22vw;
          height: 2.22vw;
          font-size: 0.833vw;
          border-radius: 50%;
          margin-left: 1.11vw;
          &.crop {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          &.cutout {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          &.locationUploadPic {
            margin-left: 0;
            background-color: var(--mixtmt_subColor1_1);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          &.showPic {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          &.moveUp,
          &.moveDown {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
        }
      }
      .item_stateIcon {
        position: absolute;
        right: -1.875vw;
        top: -1.18vw;
        width: 3.194vw;
        height: 1.805vw;
        text-align: center;
        transform: rotate(45deg);
        &.success {
          display: block;
          background: var(--mixtmt_successColor);
          .el_icon__upload_success {
            color: #fff;
          }
        }
        .el_icon__upload_success {
          display: block;
          font-size: 0.833vw;
          margin: 0.625vw 0 0 0.2778vw;
          transform: rotate(-45deg);
          svg {
            height: 1em;
            width: 1em;
          }
        }
      }
    }
  }
  .upload_btn {
    position: relative;
    width: 2.083vw;
    height: 2.083vw;
    margin-left: 1.11vw;
    overflow: hidden;
    &.noClick .upload_btn_fixed {
      pointer-events: all;
      cursor: no-drop;
      background-color: var(--mixtmt_greyColor8);
      color: var(--mixtmt_greyColor2);
    }
    &.noClick .uploadInput {
      pointer-events: none;
    }
    .uploadInput {
      margin-left: -5.208vw;
      font-size: 0.833vw;
      cursor: pointer;
    }
    .upload_btn_fixed {
      pointer-events: none;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      background-color: var(--mixtmt_whiteColor);
      color: var(--mixtmt_whiteColor);
      text-align: center;
      border-radius: 0.278vw;
      overflow: hidden;
      .btn {
        display: block;
        font-size: 0.833vw;
        line-height: 1.83vw;
      }
    }
  }
}
.mixtmt_pc {
  .editPic_row_item {
    .mixtmt_uploadList_li {
      &:hover {
        border: 1px solid var(--mixtmt_mainColor);
      }
      .mixtmt-upload-image__preview {
        .elButton_box {
          .operate_btn {
            &.crop,
            &.cutout,
            &.locationUploadPic,
            &.showPic,
            &.moveUp,
            &.moveDown {
              &:hover {
                cursor: pointer;
                background-color: var(--mixtmt_mainColor);
                svg {
                  fill: var(--mixtmt_whiteColor);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.editPic_row_item {
  .el-upload-list__item {
    padding: 0 !important;
    .el-progress__text {
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .mixtmt_uploadList_li {
    .el-icon-crop:before {
      font-size: 0.833vw;
    }
    .el-button--small.is-circle {
      padding: 0;
      width: 2.083vw;
      height: 2.083vw;
      font-size: 0.833vw;
      &.ml16 {
        margin-left: 1.11vw;
      }
      &.mAll0 {
        margin: 0;
      }
    }
    .el-progress--line {
      .el-progress__text {
        font-size: 0.974vw !important;
      }
    }
    .image_name {
      .el-input__inner {
        height: calc(3.2vw - 1px - 1px);
        line-height: 3.2vw;
        padding: 0 1vw;
      }
    }
  }
  .uploadAudio {
    .el-progress-bar {
      padding-right: 3.66667vw;
      margin-right: -4.33333vw;
    }
  }
  .programList {
    &.el-tooltip__popper {
      z-index: 1650 !important;
      font-size: 0.833vw;
      border-radius: 0.347vw;
      padding: 0.694vw;
    }
  }
}
</style>
